import { defineStore } from 'pinia';
import { ref } from 'vue';

export type AlertType = 'success' | 'error' | 'info';

export interface AlertNotification {
  id: string;
  message: string;
  type: AlertType;
}

export const useAlertsStore = defineStore('alerts', () => {
  const notifications = ref<AlertNotification[]>([]);

  const remove = (id: string) => {
    const idx = notifications.value.findIndex((n) => n.id === id);
    if (idx !== -1) {
      notifications.value.splice(idx, 1);
    }
  };

  const push = (message: string, type: AlertType = 'info') => {
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
    // While Snackbar queue is in labs, only one item at a time to avoid overlap
    // unless we decide to do it ourselves
    // notifications.value.push({ id, message, type });
    notifications.value = [{ id, message, type }];
  };

  const success = (message: string) => push(message, 'success');
  const error = (message: string) => push(message, 'error');
  const info = (message: string) => push(message, 'info');

  return {
    notifications,
    remove,
    push,
    success,
    error,
    info,
  };
});
